import app_config from "@/config/app";
import chroma from "chroma-js";
export default {
  name: "CustomizationOfApplication",
  data() {
    return {
      application_config: app_config,
      defaultConfig: {
        logo: "../../assets/logo.webp",
        background: "../../assets/landing-hero.webp",
      },
    };
  },
  computed: {
    isThisCustomContent() {
        console.log("this.application_config?.applyCustomContent",this.application_config.applyCustomContent)
      return this.application_config?.applyCustomContent || false;
    },
    getCustomHeader() {
      return this.envConfig?.customHeaderStyles || "";
    },
    getCustomSlogan() {
      return this.envConfig?.customSloganStyles || "";
    },
    isEnabledSSO()
    {
        return this.application_config?.isEnabledSSO || false;
    },
    isSysUserRegistrationEnabled()    {
        return this.application_config?.isSysUserRegistrationEnabled || false;
    },
    isTenantUserRegistrationEnabled()    {
        return this.application_config?.isTenantUserRegistrationEnabled || false;
    },

    getCustomContent() {
      return this.envConfig?.customContentStyles || "";
    },
    getCustomLogoStyles()
    {
        return this.envConfig?.customLogoStyles || '';
    },
    getLogo() {
      return this.envConfig?.logo || this.defaultConfig.logo;
    },
    getBackgroundLayer() {
      if (this.envConfig.generate_landing_page_background_from_colors) {
        let bgSource = [];
        if (
          this.company_info?.button?.background ||
          this.company_info?.banner?.background
        ) {
          bgSource.push(this.company_info?.button?.background);
          bgSource.push(this.company_info?.banner?.background);
        } else if (
          this.application_config.PRIMARY_COLOR ||
          this.application_config.SECONDARY_COLOR
        ) {
          bgSource.push("#" + this.application_config.PRIMARY_COLOR);
          bgSource = [
            ...bgSource,
            ...this.application_config.extra_supporting_color,
          ];
          bgSource.push("#" + this.application_config.SECONDARY_COLOR);
        }
        return bgSource ? this.generateColorStyle(bgSource, "-210") : "";
      }
      return `background-image: url(${
        this.envConfig?.landing_page_image || this.defaultConfig.background
      }) !important`;
    },
    getLogoInfo() {
      return this.company_info?.logo
        ? `${this.application_config.S3_BUCKET_URL}/${this.company_info.logo}`
        : this.application_config?.logo
        ? this.application_config.logo
        : this.defaultConfig.logo;
    },
    getTenantName() {
      return this.application_config.TENANT_NAME || "App";
    },
    getSpinPrimaryColor() {
      return this.company_info?.button?.background
        ? this.company_info.button.background
        : this.application_config?.PRIMARY_COLOR
        ? `#${this.application_config.PRIMARY_COLOR}`
        : "";
    },
    getSpinSecondaryColor() {
      return this.company_info?.banner?.background
        ? this.company_info.banner.background
        : this.application_config?.SECONDARY_COLOR
        ? `#${this.application_config.SECONDARY_COLOR}`
        : "";
    },
    getButtonStyles() {
      let bgSource = [];
      if (
        this.company_info?.button?.background ||
        this.company_info?.banner?.background
      ) {
        bgSource.push(this.company_info?.button?.background);
        bgSource.push(this.company_info?.banner?.background);
      } else if (
        this.application_config.PRIMARY_COLOR ||
        this.application_config.SECONDARY_COLOR
      ) {
        bgSource.push("#" + this.application_config.PRIMARY_COLOR);
        bgSource.push("#" + this.application_config.SECONDARY_COLOR);
      }
      return bgSource
        ? `${this.generateColorStyle(
            bgSource
          )} border: 1px solid rgb(0 0 0 / 22%) !important;`
        : "border: 1px solid rgb(0 0 0 / 22%) !important;";
    },
    getImageBackground() {
      let bgSource = [];
      if (
        this.company_info?.button?.background ||
        this.company_info?.banner?.background
      ) {
        bgSource.push(this.company_info?.button?.background);
        bgSource.push(this.company_info?.banner?.background);
      } else if (
        this.application_config.PRIMARY_COLOR ||
        this.application_config.SECONDARY_COLOR
      ) {
        bgSource.push("#" + this.application_config.PRIMARY_COLOR);
        bgSource.push("#" + this.application_config.SECONDARY_COLOR);
      }
      return bgSource
        ? `${this.generateColorStyle(
            bgSource
          )} border: 1px solid rgb(0 0 0 / 22%) !important;`
        : "border: 1px solid rgb(0 0 0 / 22%) !important;";
    },
    getPrimaryColor() {
      const color = this.company_info?.button?.background
        ? this.company_info.button.background
        : this.application_config?.PRIMARY_COLOR
        ? `#${this.application_config.PRIMARY_COLOR}`
        : "";
      return `color:${color} !important;`;
    },

    getPageTagsForSEO()
    {
        return (page)=>{
            console.log("page",page)
        let default_title = process.env.VUE_APP_SEO_TITLE;
        let default_description = process.env.VUE_APP_SEO_DESCRIPTION;
        let default_fav_icon = process.env.VUE_APP_SEO_FAV;
        let default_key_words= process.env.VUE_APP_SEO_KEYWORDS;
        let default_image= process.env.VUE_APP_SEO_IMAGE;
        return {
            title: default_title||'Welcome to KodeFast',
            description : default_description || 'Start building your automation today.',
            favicon : default_fav_icon|| 'favicon.png',
            keywords : default_key_words|| 'kodefast, onboarding, automation',  
            image: default_image || 'https://kodefast.net/images/logo.webp',
        }
        }
    }
  },
  methods: {
    generateColorStyle(colorInput, rotationNumber = -240) {
      if ((Array.isArray(colorInput) && !colorInput.length) || !colorInput)
        return "border: 1px solid rgb(0 0 0 / 22%) !important;";

      let colors = Array.isArray(colorInput) ? colorInput : [colorInput];
      if (colors.length === 1) {
        const base = chroma(colors[0]);
        colors = [base.brighten(1.5).hex(), base.hex(), base.darken(1.5).hex()];
      }
      const palette = chroma
        .scale(colors)
        .mode("lab")
        .colors(colors.length > 1 ? colors.length * 3 : 5);
      const middle = Math.floor(palette.length / 2);

      return (
        `background-color: ${palette[middle]} !important;` +
        ` background-image: linear-gradient(${rotationNumber}deg, ${palette.join(
          ","
        )}) !important;`
      );
    },
  },
};
